import { memo, type ReactNode } from 'react';

type GalleryCardContentProps = {
  children?: ReactNode;
};

export const GalleryCardContent = memo(({ children }: GalleryCardContentProps) => (
  <div className="pointer-events-none relative flex size-full flex-col">{children}</div>
));

GalleryCardContent.displayName = 'GalleryCardContent';
